import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { environment } from './environments/environment';

import { sentryInit } from '@vdms-hq/error-handling';
import { stripAuthLinkParams } from '@vdms-hq/auth';

stripAuthLinkParams();

if (environment.production) {
  enableProdMode();
}
const sentryEnabled = environment.type !== 'local';

if (sentryEnabled) {
  sentryInit({
    dns: environment.sentryDSN,
    env: environment.type,
    version: environment.version,
    debug: !environment.production,
    appName: 'vida',
    sampleRate: ['stage', 'demo', 'local'].includes(environment.type) ? 1 : 0.1,
    replaysEnabled: environment.type === 'production',
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
